import { useMarketingStore } from '../stores/marketing.store'

export function useMarketing() {
  const marketing = useMarketingStore((state) => state.marketing)
  const isLoading = useMarketingStore((state) => state.isLoading)
  const error = useMarketingStore((state) => state.error)
  const meta = useMarketingStore((state) => state.meta)

  const fetchMarketing = useMarketingStore((state) => state.fetchMarketing)

  const createMarketingPerson = useMarketingStore(
    (state) => state.createMarketingPerson,
  )

  const updateMarketingPerson = useMarketingStore(
    (state) => state.updateMarketingPerson,
  )

  const deleteMarketingPerson = useMarketingStore(
    (state) => state.deleteMarketingPerson,
  )

  const clearError = useMarketingStore((state) => state.clearError)

  return {
    marketing,
    meta,
    isLoading,
    error,
    fetchMarketing,
    createMarketingPerson,
    updateMarketingPerson,
    deleteMarketingPerson,
    clearError,
  }
}
